import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerManagerDeleteParams, TypePatchOwnerManagerDeleteResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 담당자 정보 삭제
 */
const usePatchOwnerManagerDelete = () => {
  const endPoint = '/api-owner/owner-manager/delete';

  const patchOwnerManagerDelete = async (params: TypePatchOwnerManagerDeleteParams) => {
    return axiosInstance
      .patch<TypePatchOwnerManagerDeleteResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchOwnerManagerDelete };
};

export default usePatchOwnerManagerDelete;
